import React from 'react';

function Navbar() {
  return (
    <div>
      <nav className="navbar navbar-light bg-light">
        <a
          className="navbar-brand"
          href="https://github.com/nicholasherious/QR-Code-Generator"
        >
          QR Generator
        </a>
      </nav>
    </div>
  );
}

export default Navbar;
